<template>
  <div id="app" :hideContacto="hideContacto" :imContacto="imContacto" :lang="lang">
    <app-header></app-header>
    <router-view/>
    <banner-contacto v-if="!imContacto & !ismovil"></banner-contacto>
    <app-footer v-if="!hideContacto"></app-footer>  
    <popup-bodega></popup-bodega>
  </div>
</template>

<script>



  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import bannerContacto from '@/components/parts/banner-contacto';
  import popupBodega from '@/components/parts/popup-bodega';

  import {mapGetters} from 'vuex';

  export default {
    name: 'App',
    components : {
      'app-header' : header,
      'app-footer' : footer,
      'cookie-law' : CookieLaw,
      'banner-contacto' : bannerContacto,
      'popup-bodega' : popupBodega
    },
    mounted (){

    },
    watch : {
      '$route' : function(){
        // let that = this;
        // setTimeout(function(){
        //   that.waypoints();
        // },100);
      }
    },
    computed : {
      hideContacto : function(){
        return (this.$route.name.includes('proceso'));
      },
      imContacto : function(){
        return (this.$route.name == "contacto");
      },
      ismovil : function(){
        return ($(window).height() < 800);
      },
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
  }
</script>

<style lang="scss">

  @import "@/assets/css/colors.scss";

  #app{
    position: relative;
    overflow: hidden;
    /* padding-bottom: 295px; */
    &[hideContacto=true],
    &[imContacto=true]{
      padding-bottom: 0;
    }

    &[imContacto=true]{
     background: $mud-brown;
   }
 }

 @media screen and (max-height: 880px){

  #app{
    /* padding-bottom: 50px; */
    > .banner-contacto{
      display: none;
    }
    > .banner-contacto[imContacto=true]{
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
    }
  }
}

@media screen and (max-width: 830px){
  #app{
    /* padding-bottom: 100px; */
  }
}

@media screen and (max-width: 700px){
  #app{
    /* padding-bottom: 103px; */
  }
}

@import "./assets/css/colors.scss";
@import "./assets/css/style.scss";
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700,800|Yeseva+One');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
@import './assets/css/slick.css';
</style>



// WEBPACK FOOTER //
// src/App.vue